export class ComplianceReportModel {
  total_Reports = 0;
  total_Reports_Filed = 0;
  total_Reports_Filed_by_Client = 0;
  total_Reports_Not_Sent = 0;
  total_Reports_Not_Received = 0;
  total_Reports_with_No_Remittance = 0;
}

export class ReportFilterModel {
  userName: string;
  specialistId: number;
  startDate: Date;
  endDate: Date;
}

export class BriefingReportModel {
  DisplayDate: string;
  CompanyName: string;
  RecordCount = 0;
}

export class BriefingReportFilterModel {
  month: number;
  year: number;
  companyId: number;
  fromDate: any;
  toDate: any;
  stateID: any;
  pageNumber: any;
  briefingTypesId: any;
}

export class VoIPReportFilterModel {
  fromDate: any;
  toDate: any;
}

export class VoIPUpdatesJurisdictionCountsModel {
  StateName: string;
  TitleCount = 0;
}

export class VoipReportFilterModel {
  month: number;
  year: number;
  companyId: number;
  fromDate: any;
  toDate: any;
  stateID: any;
  pageNumber: any;
  briefingTypesId: any;
}

export class AllActiveSubscribersFilterModel {
  companyId: number;
  stateID: any;
  productId: any;
}


export class VoipReports {
  companyName: any;
  companyId: number;
  stateName: any;
  licenceCount: any;
  isDemo: boolean;
  isComp: boolean;
}

export class AllActiveCompanyReportFilterModel {
   companyId: number;
   stateID: any;
   productId: any;
}

export class AllActiveCompany {
  companyName: any;
  companyId: number;
  stateName: any;
  licenceCount: any;
  isDemo: boolean;
  isComp: boolean;
}

export class WirelessFilterModel {
  fromDate: any;
  toDate: any;
}

export class IpcsReportFilterModel {
   month: any;
   year: any;
   companyId: number;
   fromDate: any;
   toDate: any;
   stateID: any;
   pageNumber: any;
}

export class IpcsReports {
  companyName: any;
  companyId: number;
  stateName: any;
  licenceCount: any;
  isDemo: boolean;
  isComp: boolean;
}

export class IpcsTypeModel {
  ipcsTypeName?: any;
  titleCount?: any;
}

export class IpcsJurisdictionModel {
  stateName?: any;
  titleCount?: any;
}

export class IPCSUpdatesCountsByUpdateCategoryReportsModel {
  updateCategoryName?: any;
  categoryWiseUpdatesCount?: any;
}

export class BriefingReportFilterModelV2 {
  companyId: number;
  stateID: any;
  BriefingTypesId: any;
  pageNumber: any;
  pageSize: any;
  orderBy: any;
  isExport: any;
}

export class BriefingProcessingReportFilterModel {
  fromDate: any;
  toDate: any;
  stateID: any;
  pageNumber: any;
  pageSize: any;
  orderBy: any;
  isExport: any;
}


export class CompanySummaryBriefingFilterModel {
  companyId: number;
  fromDate: any;
  toDate: any;
  pageNumber: any;
  pageSize: any;
  orderBy: any;
  isExport: any;
}

export class MonthlyBillingOfBriefingsFilterModel {
  companyId: number;
  fromDate: any;
  toDate: any;
  pageNumber: any;
  pageSize: any;
  orderBy: any;
  isExport: any;
}
